export const getGASesionId = () => {
  var gaCookie = document.cookie.match(/_ga_[^=]+=([^;]+)/);

  if (gaCookie && gaCookie[1]) {
    var value = gaCookie[1];

    if (value.indexOf('$') > -1) {
      // s = Session Start Timestamp (cuándo inició la sesión)
      var sMatch = value.match(/s(\d+)/);

      // o = Engagement Count (número de interacciones/eventos en esta sesión)
      var oMatch = value.match(/o(\d+)/);

      // g = Session Number (número de sesión del usuario, cuántas veces ha visitado)
      var gMatch = value.match(/g(\d+)/);

      // t = Current Timestamp (timestamp actual/más reciente de la sesión)
      var tMatch = value.match(/t(\d+)/);

      if (sMatch && oMatch && gMatch && tMatch) {
        var sessionId =
          sMatch[1] + '.' + oMatch[1] + '.' + gMatch[1] + '.' + tMatch[1];
        return sessionId;
      } else {
        return 'no aplica';
      }
    } else {
        return 'no aplica';
    }
  } else {
    return 'no aplica';
  }

  return 'no aplica';
};
